import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('StarterPackItem').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // overflow: 'hidden',
    width: 'fit-content',
    gap: '8px',
  },

  content: {
    position: 'relative',
    display: 'flex',
    minWidth: '100px',
    justifyContent: 'center',
    alignItems: 'center',
    aspectRatio: '1/1',
    background: 'rgba(240, 245, 250, 0.05)',
    borderRadius: theme.sizes.radiuses.l,
    border: '1px solid',
    borderColor: theme.colors.borders.default,
    overflow: 'hidden',

    img: {
      maxWidth: '100px',
    },

    '&[data-kind="1"]': {
      borderColor: theme.colors.borders.legendary,
    },
    '&[data-kind="2"]': {
      borderColor: theme.colors.borders.rare,
    },
    '&[data-kind="3"]': {
      borderColor: theme.colors.borders.rare,
      aspectRatio: 'unset',
      width: '100%',
      height: 'auto',
      padding: 0,
      overflow: 'visible',
      background: 'transparent',

      img: {
        width: '100%',
        height: 'auto',
        objectFit: 'contain',
        display: 'block',
        borderRadius: theme.sizes.radiuses.l,
      },
    },

    '&[data-length="1"]': {
      width: '120%',
      aspectRatio: '16/12',
    },
  },

  itemValue: {
    color: 'white',
    position: 'absolute',
    bottom: '0px',
    right: '4px',
    fontFamily: 'Space Grotesk',
    fontWeight: '700',
    fontSize: '28px',
    textAlign: 'right',
    padding: '0px 4px',
    verticalAlign: 'middle',
    textTransform: 'uppercase',
  },

  itemPriceContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',

    img: {
      width: '16px',
    },

    span: {
      color: 'white',
      fontSize: '18px',
      fontWeight: 450,
    },
  },

  specialMark: {
    position: 'absolute',
    left: '4px',
    top: '4px',
    display: 'flex',
    gap: '2px',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50px',
    borderRadius: '24px',

    span: {
      color: 'white',
      fontSize: '12px',
      lineHeight: '18px',
      fontWeight: 450,
    },
  },
}))
